export default __webpack_public_path__ + "static/uCall x Tai Chinh_page-0002-1c59e53ee80525b475b4cc692a0a63d6.jpg";